import { useCallback, useEffect, useRef } from 'react';

const useDebounce = (callback: () => void, timeout: number) => {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Update the callback reference if it changes
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedCallback = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      callbackRef.current();
    }, timeout);
  }, [timeout]);

  useEffect(
    () =>
      // Clear the timeout when the component unmounts
      () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      },
    []
  );

  return debouncedCallback;
};

export default useDebounce;
